angular.module('app.currentPlatform.currentPlatformDetailService', [])
  .factory('app.currentPlatform.currentPlatformDetailService', [
    '$http', 'hostnameMatchService',
    function ($http, hostnameMatchService) {
      "use strict";

      /**
       * @type {{platform: Platform|null, retrieve: retrieve, isBranded: isBranded}}
       */
      let service = {
        platform: null,
        retrieve: function () {
          return $http.get(window.location.api('platforms/current'))
            .then(function (response) {
              service.platform = response.data;
              let siteHostname = hostnameMatchService.hostname();

              if (window.location.platform(undefined, siteHostname) && service.platform.strplatformid !== window.location.platform(undefined, siteHostname)) {
                let platform = service.platform.strplatformid ? service.platform.strplatformid : null;
                let location = window.location.platform(platform, siteHostname);
                if (location !== `//${window.location.hostname}`) {
                  window.location = window.location.platform(service.platform.strplatformid, siteHostname);
                }
              }
            });
        },
        isBranded: function () {
          return !!(service.platform && service.platform.strplatformid !== 'www');

        },
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/currentPlatform/currentPlatformDetailService.js